import { get } from "lodash";
import { ADD_RESOURCE_OPERATIONS } from "../constants/operations.js";

export function operationEnabled(name, enabledOperations) {
  if (!enabledOperations) return false;
  return enabledOperations.findIndex(item => item === name) > -1;
}

export function operationPermitted(name, operations, permissions = {}) {
  if (!operations) return false;

  const operation = operations.find(item => item.name === name);

  if (operation) {
    const { noRequiredPermissions, requiredPermissions } = operation;

    if (noRequiredPermissions === true) {
      return true;
    } else if (requiredPermissions) {
      for (const permission of requiredPermissions) {
        if (permissions[permission] === true) {
          return true;
        }
      }
    }
  }

  return false;
}

export function operationAvailable(
  operationName,
  operations,
  enabledOperations,
  permissions
) {
  const availability = {
    permitted: false,
    enabled: false,
    available: false
  };

  if (operations) {
    availability.permitted = operationPermitted(
      operationName,
      operations,
      permissions
    );
  }

  if (enabledOperations) {
    availability.enabled = operationEnabled(operationName, enabledOperations);
  }

  availability.available = availability.permitted && availability.enabled;

  return availability;
}

// -- HELPERS -- //

export function operationAvailability(name, operations, warnings = true) {
  if (!operations) {
    if (warnings) console.warn(`No operations passed for ${name}`);
    return {};
  }

  const operation = operations.find(item => item.name === name);

  if (operation && operation.availability) {
    return operation.availability;
  }

  return {};
}

// --

export function getOperation(name, operations, enabledOperations, permissions) {
  if (!operations || !enabledOperations) return false;

  const operation = operations.find(item => item.name === name);

  const enabled = operationEnabled(name, enabledOperations);

  let permitted = true;
  if (typeof permissions === "object") {
    permitted = operationPermitted(name, operations, permissions);
  }

  if (!operation) {
    console.warn(`WARNING: The operation "${name}" could not be found.`);
  }

  if (!enabled || !permitted) {
    console.warn(
      `WARNING: The operation "${name}" was not enabled "${enabled}" or was not permitted "${permitted}".`
    );
  }

  return enabled && permitted ? operation : undefined;
}

export function buildOperationOptions(options) {
  const {
    showErrorModal = true,
    isFatal = false,
    autoComplete = true
  } = options;

  const operationOptions = {
    ...options,
    showErrorModal,
    isFatal,
    autoComplete
  };

  delete operationOptions.success;
  delete operationOptions.fail;

  return operationOptions;
}

export function addResourceOperationsAvailable(operations) {
  if (!operations) return false;

  for (let element of ADD_RESOURCE_OPERATIONS) {
    const createAvailability = operationAvailability(element, operations);
    if (createAvailability && createAvailability.available) return true;
  }

  return false;
}
